import React, { useState } from 'react';
import Header from '../navbar/Header';
import Container from '../Container';
import Content from '../Content';
import Navbar from '../navbar/Navbar';
import TaskList from './TaskList';

function Task() {
    const [loading, setLoading] = useState(false);
    return ( 
        <Container>
            <Navbar/>

            <Content>
            <Header/>

                <TaskList/>
            </Content>
        </Container>
     );
}

export default Task;